import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContaRef } from '../models/contaref';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class ContaRefService {

  constructor(private http: HttpClient) {
  }

  consultar() {
    return this.http.get<ContaRef>(globals.apiUrl + '/api/ContaRef/Buscar');
  }

  salvar(contaRef: ContaRef) {
    return this.http.post(globals.apiUrl + '/api/ContaRef/Salvar', contaRef);
  }
}
